import { Button, Table } from "antd";
import { useState } from "react";
import { PAGE_SIZE } from "features/ConsultRequest/core/constants";
import { formatDateTime } from "features/ConsultRequest/core/utils";
import { listNotes } from "features/ConsultRequest/data/apiAdapters";
import { useConsultQuery } from "features/ConsultRequest/data/hooks";
import AddNoteModal from "./AddNoteModal";
import ConsultErrorState from "./ConsultErrorState";

export default function NotesTab({ requestId, canAddNote, onNoteAdded, onStale }) {
  const [page, setPage] = useState(1);
  const [open, setOpen] = useState(false);
  const notes = useConsultQuery(listNotes, [requestId, { page, size: PAGE_SIZE }]);
  const columns = [
    { title: "NGÀY GỬI", width: 180, render: (_, n) => formatDateTime(n.createdAt) },
    {
      title: "NGƯỜI GHI",
      width: 220,
      render: (_, n) => `${n.author?.name || ""}${n.author?.roleName ? ` (${n.author.roleName})` : ""}`,
    },
    { title: "NỘI DUNG GHI CHÚ", dataIndex: "content" },
  ];
  if (notes.error) return <ConsultErrorState error={notes.error} onRetry={notes.refetch} />;
  return (
    <div>
      {canAddNote && (
        <Button style={{ marginBottom: 12 }} onClick={() => setOpen(true)}>
          + Thêm ghi chú
        </Button>
      )}
      <Table
        rowKey="id"
        loading={notes.loading}
        columns={columns}
        dataSource={notes.data?.items || []}
        locale={{ emptyText: "Chưa có ghi chú nào." }}
        pagination={{
          current: page,
          pageSize: PAGE_SIZE,
          total: notes.data?.total || 0,
          showSizeChanger: false,
          onChange: setPage,
        }}
      />
      <AddNoteModal
        visible={open}
        requestId={requestId}
        onClose={() => setOpen(false)}
        onStale={onStale}
        onAdded={() => {
          if (page === 1) notes.refetch();
          else setPage(1);
          onNoteAdded?.();
        }}
      />
    </div>
  );
}
